import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAclByRoleType, IAclRaw } from 'src/app/shared/types/acl.types';
import { HttpUtilsService } from 'src/app/shared/http-utils/http-utils.service';
import { ItemResponseWrapper, ListResponseWrapper } from 'src/app/shared/http.types';
import { User } from 'src/app/shared/types/users.types';
import { environment } from 'src/environments/environment';

export interface IGetUsersPayload {
  advertiserId: string;
  onlyActive?: boolean;
}

export interface IUpdateUserStatePayload {
  userId: User['id'];
  advertiserId: string;
  state: 'activate'|'deactivate',
}

export interface IChangeUserRolePayload {
  advertiserId: string;
  userId: string;
  role: User.GroupName;
}

@Injectable({ providedIn: 'root' })
export class AuthUserHttpService {
  private httpClient: HttpClient;
  private httpUtils: HttpUtilsService;

  constructor() {
    this.httpClient = inject(HttpClient);
    this.httpUtils = inject(HttpUtilsService);
  }

  public getUsers({ advertiserId, onlyActive = false }: IGetUsersPayload): Observable<ListResponseWrapper<User>> {
    return this.httpClient
      .get<ListResponseWrapper<User>>(
        `${environment.backendBaseUrl}/auth/users/advertiser/${advertiserId}`,
        {
          params: { onlyActive }
        }
      );
  }

  /**
   * @todo: Use more precised type(Observable<any>)
   */
  public changeUserState({ userId, advertiserId, state }: IUpdateUserStatePayload): Observable<any> {
    return this.httpClient
      .put(`${environment.backendBaseUrl}/auth/users/${userId}/advertiser/${advertiserId}/${state}`, null);
  }

  public changeRole({ advertiserId, userId, role }: IChangeUserRolePayload): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.backendBaseUrl}/auth/users/${userId}/advertiser/${advertiserId}/change-roles`,
      null,
      {
        params: { roles: role },
      },
    );
  }

  public getAcl(): Observable<IAclRaw> {
    return this.httpClient.get<ItemResponseWrapper<IAclRaw>>(`${environment.backendBaseUrl}/auth/users/acl`)
      .pipe(
        map(this.httpUtils.entityWrapperResponseMapper),
      );
  }

  public getAclByAccount(accountId: string): Observable<IAclByRoleType> {
    return this.httpClient.get<ItemResponseWrapper<IAclByRoleType>>(`${environment.backendBaseUrl}/auth/users/acl/${accountId}`)
      .pipe(
        map(this.httpUtils.entityWrapperResponseMapper),
      );
  }
}
